module.exports = __webpack_public_path__ + "static/media/tastemakers-campus-2.9ba63ca9.png";